/** 
 * Enumeration des types d'authentification supporté par Dcx
 */
enum AuthentificationMethodEnum{
    /** Authentification par login/mdp */
    Basic = 0,
    /** Authentification grâce à OpenId Connect (SSO) */
    Oidc = 1
}

export default AuthentificationMethodEnum;
